import { Link } from 'react-router-dom'
import { RoutesEnum } from '../lib/routes'
import { useLang } from '../lib/useLang'

export default function Footer() {
  const { t } = useLang()
  const year = new Date().getFullYear()
  return (
    <footer id='contact' className='hairline-top'>
      <div className='mx-auto max-w-6xl px-6 lg:px-10 py-16 md:py-20'>
        <div className='grid md:grid-cols-2 gap-12 md:gap-8 items-start'>
          <div>
            <div className='text-[0.95rem] font-semibold tracking-[0.18em] mb-4'>
              MODELLER
            </div>
            <p className='text-[0.92rem] text-ink/65 max-w-sm leading-[1.65]'>
              {t('lp.footer.tagline')}
            </p>
          </div>

          <div className='grid grid-cols-2 sm:grid-cols-3 gap-8 md:justify-self-end'>
            <div>
              <div className='label-eyebrow mb-4'>{t('lp.footer.product')}</div>
              <ul className='space-y-2.5'>
                <li><Link to={RoutesEnum.PLANS} className='footer-link'>{t('lp.footer.pricing')}</Link></li>
                <li><Link to={RoutesEnum.USE_CASES} className='footer-link'>{t('lp.footer.useCases')}</Link></li>
                <li><a href={RoutesEnum.RESEARCH} className='footer-link'>{t('lp.footer.research')}</a></li>
                <li><a href='#platform' className='footer-link'>{t('lp.footer.platform')}</a></li>
              </ul>
            </div>
            <div>
              <div className='label-eyebrow mb-4'>{t('lp.footer.company')}</div>
              <ul className='space-y-2.5'>
                <li><Link to={RoutesEnum.CONTACT} className='footer-link'>{t('lp.footer.contact')}</Link></li>
                <li><Link to={RoutesEnum.PRIVACY} className='footer-link'>{t('lp.footer.privacy')}</Link></li>
                <li><Link to={RoutesEnum.TERMS} className='footer-link'>{t('lp.footer.terms')}</Link></li>
                <li><Link to={RoutesEnum.CONSENT} className='footer-link'>{t('lp.footer.consent')}</Link></li>
                <li><Link to={RoutesEnum.COOKIES} className='footer-link'>{t('lp.footer.cookies')}</Link></li>
              </ul>
            </div>
            <div>
              <div className='label-eyebrow mb-4'>{t('lp.footer.account')}</div>
              <ul className='space-y-2.5'>
                <li><Link to={RoutesEnum.AUTH} className='footer-link'>{t('lp.footer.logIn')}</Link></li>
                <li><Link to={RoutesEnum.CONTACT} className='footer-link'>{t('lp.footer.getStarted')}</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className='mt-16 pt-8 hairline-top flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4'>
          <span className='text-xs text-muted tracking-[0.06em]'>
            © {year} Modeller. {t('lp.footer.rights')}
          </span>
          <span className='text-xs text-muted mono'>
            modeller.tech
          </span>
        </div>
      </div>
    </footer>
  )
}
